module.exports = __webpack_public_path__ + "img/de_l.b7c92cb1.png";